import { render, staticRenderFns } from "./MenuNestableLink.vue?vue&type=template&id=2ec3bc4b&scoped=true&"
import script from "./MenuNestableLink.vue?vue&type=script&lang=js&"
export * from "./MenuNestableLink.vue?vue&type=script&lang=js&"
import style0 from "./MenuNestableLink.vue?vue&type=style&index=0&id=2ec3bc4b&lang=scss&scoped=true&"
import style1 from "./MenuNestableLink.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3bc4b",
  null
  
)

export default component.exports